import React, { useState } from 'react';
import FGAssignment from '../GoodsTransfer/FGAssignment';
import { PendingFgList } from '@/components/flexi/PendingFgList';

export default function FlexiFGAssignment() {
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <FGAssignment
      title="Flexi — FG Assignment"
      subtitle="Assign Finished Goods to bundles received in Flexi"
      backRoute="/sections/flexi"
      apiBase="/flexi/fg-assignment"
      checkBunFormat={false}
      onAssigned={() => setReloadKey((k) => k + 1)}
    >
      <PendingFgList reloadKey={reloadKey} />
    </FGAssignment>
  );
}
